import {FormGroup} from "@angular/forms";

export class CustomValidators {

  public static checkPasswords(group: FormGroup) {
    if(group === null) return null;
    const password = group.get('password').value;
    const password2 = group.get('password2').value;

    const matchingControl = group.controls['password2'];

    if( password === password2 ){
      matchingControl.setErrors(null);
      return null;
    }else{
      matchingControl.setErrors({ invalid: true });
      return { invalid: true };
    }
  }

}
